import { Button, ButtonSizes, ButtonVariants } from '@triumph/design-system';

import { BannerWrapper } from './OutOfSyncBanner.StyledComponents';

interface OutOfSyncBannerProps {
    show: boolean;
    onRefresh: () => void;
}

export const OutOfSyncBanner = ({ show, onRefresh }: OutOfSyncBannerProps) => {
    if (!show) return null;

    return (
        <BannerWrapper data-testid="out-of-sync-banner">
            <span>New Activity detected. Click here to</span>
            <Button
                variant={ButtonVariants.secondary}
                size={ButtonSizes.small}
                onClick={onRefresh}
                data-testid="out-of-sync-refresh-button"
            >
                REFRESH
            </Button>
        </BannerWrapper>
    );
};
